import { Link } from 'react-router';

import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// Today's record as the page's main call to action, in the accent colour:
// how far it is, and the way in. With nothing recorded, Record today starts
// at the first question; once anything is recorded, Edit today's record
// opens the check, where every answer links to its own step.
//
// The Journal entry button drawn beside it joins when the Journal exists.
export function TodayRecord({ day }) {
  const { text } = useLanguage();

  let status = text.notRecordedYet;
  let action = <Link className={ styles.action } to={ `/diary/record/${ day.date }/mood` }>{ text.recordToday }</Link>;

  if (day.completeness === 'PARTIAL') {
    status = text.partlyRecorded;
  }

  if (day.completeness === 'COMPLETE') {
    status = text.allRecorded;
  }

  if (day.completeness !== 'NONE') {
    action = <Link className={ styles.action } to={ `/diary/record/${ day.date }/check` }>{ text.editTodaysRecord }</Link>;
  }

  return (
    <section className={ styles.card } aria-labelledby='today-record-title'>
      <div className={ styles.heading }>
        <h2 id='today-record-title' className={ styles.title }>{ text.todaysRecord }</h2>
        <span className={ styles.status }>{ status }</span>
      </div>

      { action }
    </section>
  );
}
